import { createSelector } from 'reselect';
import { SelectedCustomerSelector } from './customer.selectors';
export var CurrentRemarksSelector = createSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return selectedCustomer.remarks.data.asMutable({
    deep: true
  });
});
export var IsFetchingRemarksSelector = createSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return selectedCustomer.remarks.isFetchingRemarks;
});
export var IsUpdatingRemarkSelector = createSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return selectedCustomer.remarks.isUpdatingRemark;
});
export var IsCreatingRemarkSelector = createSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return selectedCustomer.remarks.isCreatingRemark;
});
export var IsRemarksServiceAvailableSelector = createSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return selectedCustomer.remarks.isServiceAvailable;
});
export var RemarksLastAttemptErrorSelector = createSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return selectedCustomer.remarks.remarksErrors;
});
export var RemarkToEditSelector = createSelector([SelectedCustomerSelector], function (selectedCustomer) {
  var remarkToEdit = selectedCustomer.remarks.remarkToEdit;
  return remarkToEdit ? remarkToEdit.asMutable({
    deep: true
  }) : null;
});